// @mui material components
import Icon from '@mui/material/Icon';
import Tooltip from '@mui/material/Tooltip';

// Argon Dashboard 2 PRO MUI components
import ArgonBox from 'component/Argon/ArgonBox';
import ArgonTypography from 'component/Argon/ArgonTypography';
import useCart from 'hook/useCart';

function ActionCell({ row }) {
  const { removeItem } = useCart();
  return (
    <ArgonBox display="flex" alignItems="center">
      <ArgonBox
        ml={2}
        onClick={() => {
          removeItem(row.original.uuid);
        }}
      >
        <ArgonTypography
          variant="body1"
          color="error"
          sx={{ cursor: 'pointer', lineHeight: 0 }}
        >
          <Tooltip title="ลบ" placement="left">
            <Icon>delete_forever</Icon>
          </Tooltip>
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox >
  );
}

export default ActionCell;
